import { createContext } from 'react';

import type { ScrollLockMethods } from './useScrollLockManager';

export const ScrollLockContext = createContext<ScrollLockMethods>({
  lockScroll: () => {},
  unlockScroll: () => {},
  isScrollLockActive: () => false,
});
